import { Game, GameKind, TriviaConfiguration } from "../../gql/graphql";

export type TriviaGame = Omit<Game, "configuration"> & {
  configuration: TriviaConfiguration;
};
export function isTriviaGame(game?: Game | null): game is TriviaGame {
  return game?.kind === GameKind.Trivia;
}
